export const formatCategoryName = (categoryName = "") =>
  categoryName.includes("-")
    ? categoryName.replace("-", " ")
    : categoryName.replace(" ", "-");
